import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { addRequestNote, NewRequestNote } from 'RestAPIs/roster/notes';

// Todo: fix this hook at other places. Update implementation of this hook in FlexHistory.
const useAddRequestNote = ({ isWebSocketEnabled = false }) => {
  const queryClient = useQueryClient();

  return useMutation((params: NewRequestNote) => addRequestNote(params), {
    onSuccess: () => {
      !isWebSocketEnabled &&
        queryClient.invalidateQueries(['requestNotes', 'list']);
      showSuccessSnackbar();
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};

export default useAddRequestNote;
